
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(3.5 3.5)","fill":"#FFF","fill-rule":"nonzero"}},[_c('circle',{attrs:{"cx":"4.125","cy":"10.5","r":"1.875"}}),_c('path',{attrs:{"d":"M16.5 11.25v2.063a.187.187 0 01-.188.187H1.688a.187.187 0 01-.187-.188V9.376H0V18h1.5v-1.5c0-.104.084-.188.188-.188h14.624c.104 0 .188.084.188.188V18H18v-6.75h-1.5z"}}),_c('path',{attrs:{"d":"M7.125 12.375h8.25A.375.375 0 0015.75 12a2.289 2.289 0 00-1.725-2.224L10.01 8.585a2.625 2.625 0 00-3.26 2.547V12c0 .207.168.375.375.375zm6-4.261l1.5.511V5.25h-1.5zM11.775 4.5h4.2a.75.75 0 00.735-.9l-.6-3a.75.75 0 00-.735-.6h-3a.75.75 0 00-.735.604l-.6 3a.75.75 0 00.735.896z"}})])])
          )
        }
      }
    